'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DialogSurfaceContext: function() {
        return DialogSurfaceContext;
    },
    DialogSurfaceProvider: function() {
        return DialogSurfaceProvider;
    },
    useDialogSurfaceContext_unstable: function() {
        return useDialogSurfaceContext_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const defaultContextValue = false;
const DialogSurfaceContext = /*#__PURE__*/ _react.createContext(undefined);
const DialogSurfaceProvider = DialogSurfaceContext.Provider;
const useDialogSurfaceContext_unstable = ()=>{
    var _React_useContext;
    return (_React_useContext = _react.useContext(DialogSurfaceContext)) !== null && _React_useContext !== void 0 ? _React_useContext : defaultContextValue;
};
